import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import { ReactComponent as SubmenuIcon } from '../../../../../assets/icons/Navegation/submenu-flecha.svg';
import { ReactComponent as LineAssignmentsIcon } from '../../../../../assets/icons/Navegation/vinculacion.svg';
import { headerTitleStyle, icons, triangle } from '../Styles/StylesIcons';
import GenericCollapse from './GenericCollapse';
import GenericNavListItem from './GenericNavListItem';
import GenericListItemButton from './MenuItemWithSubmenu';

const TriangleIcon = (props) => <SubmenuIcon style={triangle} {...props} />;

const clearLineAssignmentsSessionState = () => {
  sessionStorage.removeItem('lineAssignments:searchNavigationState');
  sessionStorage.removeItem('lineAssignments:orderNavigationState');
  sessionStorage.removeItem('lineAssignments:linesNavigationState');

  // Also clear dynamic keys used for persisted line lists by legal_id/order_id.
  for (let index = sessionStorage.length - 1; index >= 0; index -= 1) {
    const key = sessionStorage.key(index);

    if (key?.startsWith('lineAssignmentsLines:')) {
      sessionStorage.removeItem(key);
    }
  }
};

const LineAssignmentsMenu = ({
  userPermissions,
  openLineAssignments,
  handleClickLineAssignments,
  activeStyle,
  drawerOpen,
  header,
  handlePopoverOpen,
  handlePopoverClose,
  openPopover,
  anchorEl,
}) => {
  const submenuContent = (
    <>
      {userPermissions?.includes('LINKED_UP_REPORTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='LINKED_UP_REPORTS'
          to='/list/orders-vinculation'
          title='Ordenes de vinculación'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('COMPANY_LINKED_UP_ORDERS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='COMPANY_LINKED_UP_ORDERS'
          to='/line-assignments/search-orders'
          title='Personas morales'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
          onClick={clearLineAssignmentsSessionState}
        />
      )}
    </>
  );

  return (
    <>
      {(userPermissions?.includes('LINKED_UP_REPORTS') ||
        userPermissions?.includes('COMPANY_LINKED_UP_ORDERS')) && (
        <>
          <Divider style={{ margin: '0 0 4px 0' }} />
          {drawerOpen && (
            <>
              {header?.lines.kind === 'header' && (
                <div style={headerTitleStyle}>{header.lines.title}</div>
              )}
            </>
          )}
          <GenericListItemButton
            onClick={drawerOpen ? handleClickLineAssignments : handlePopoverOpen}
            className={'layout-menu-submenu'}
            title='Vinculación'
            IconComponent={(props) => <LineAssignmentsIcon style={icons} {...props} />}
            openMenu={openLineAssignments}
          />
          {drawerOpen && (
            <GenericCollapse
              className={'layout-menu-submenu-options'}
              openMenu={openLineAssignments}
              userPermissions={userPermissions}
            >
              {submenuContent}
            </GenericCollapse>
          )}
          {!drawerOpen && (
            <Popover
              open={openPopover}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              onBlur={handlePopoverClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: { minWidth: 220 },
                onMouseLeave: handlePopoverClose,
              }}
            >
              <div style={{ padding: 8 }}>{submenuContent}</div>
            </Popover>
          )}
        </>
      )}
    </>
  );
};

export default LineAssignmentsMenu;
